import { Form, Input, Radio } from 'antd';
import { MessageDescriptor, useIntl } from 'react-intl';

import { i18n } from '../../config';

import styles from './OrderReasonFields.module.scss';

type OrderReasonFieldsProps<Reason extends number> = {
  reasonOptions: Reason[];
  reasonMessages: Record<Reason, MessageDescriptor>;
};

export const OrderReasonFields = <Reason extends number>(
  props: OrderReasonFieldsProps<Reason>,
) => {
  const { reasonOptions, reasonMessages } = props;

  const { formatMessage } = useIntl();

  return (
    <>
      <Form.Item
        name="reason"
        label={formatMessage(i18n.orderReasonMessages.reasonLabel)}
        rules={[
          {
            required: true,
            message: formatMessage(i18n.orderReasonMessages.reasonRequired),
          },
        ]}
      >
        <Radio.Group className={styles.radioGroup}>
          {reasonOptions.map((reasonCode) => (
            <Radio key={reasonCode} value={reasonCode}>
              {formatMessage(reasonMessages[reasonCode])}
            </Radio>
          ))}
        </Radio.Group>
      </Form.Item>

      <Form.Item
        name="comment"
        label={formatMessage(i18n.orderReasonMessages.commentLabel)}
      >
        <Input.TextArea
          rows={3}
          placeholder={formatMessage(
            i18n.orderReasonMessages.commentPlaceholder,
          )}
        />
      </Form.Item>
    </>
  );
};
